import { Sport } from '../../models/sport';

export class SportState {
  sports: Sport[] = [];
  selectedSport!: Sport;
}
